// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"286":"692446d4","455":"e0908b41","655":"206e7ff8","814":"3f3b3e5e","978":"46878281"}[chunkId] + ".chunk.js";
};